import { Link } from 'react-router-dom';
import { projects } from '@/mocks/projects';

type Project = (typeof projects)[number];

function ProjectCard({ project, className }: { project: Project; className?: string }) {
  return (
    <Link to={`/proyectos/${project.slug}`} className={`group block reveal ${className ?? ''}`}>
      <div className="relative overflow-hidden bg-neutral-100">
        <img
          src={project.image}
          alt={`${project.name} — diseño arquitectónico ${project.category.toLowerCase()} en ${project.zone}`}
          title={`${project.name} · ${project.category} · San Luis Potosí`}
          className="block w-full h-auto transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <span className="absolute top-4 left-4 w-10 h-10 border-t border-l border-white/50"></span>
        <span className="absolute bottom-4 right-4 w-10 h-10 border-b border-r border-white/50"></span>
      </div>
      <div className="mt-5 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h3 className="font-display text-xl md:text-2xl font-medium tracking-tightest group-hover:opacity-60 transition-opacity">
          {project.name}
        </h3>
        <span className="overline text-neutral-400">{project.area}</span>
      </div>
      <p className="text-sm text-neutral-500 mt-2">
        {project.category}
        {project.category === 'Residencial' && project.zone.includes('Soledad')
          ? ' (remodelación)'
          : ''}
        {' · '}
        {project.zone} · {project.year}
      </p>
    </Link>
  );
}

export default function FeaturedProjects() {
  const featured = projects.filter((p) => p.featured);

  return (
    <section id="proyectos" className="bg-white text-neutral-900 scroll-mt-20">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20 reveal">
          <div>
            <p className="overline text-neutral-400">Proyectos destacados</p>
            <h2 className="font-display font-medium tracking-tightest text-[clamp(2rem,5vw,4.5rem)] mt-4">
              Obra reciente
            </h2>
          </div>
          <Link
            to="/proyectos"
            className="whitespace-nowrap inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] u-link"
          >
            Ver todos los proyectos <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <ProjectCard project={featured[0]} className="md:col-span-7" />
          <ProjectCard project={featured[1]} className="md:col-span-5 md:mt-24" />
          <ProjectCard project={featured[2]} className="md:col-span-7 md:col-start-6" />
        </div>
      </div>
    </section>
  );
}